import * as FileSaver from 'file-saver';
import * as moment from 'vendors/moment-locale-th';

import { ApprovalUpdateByType, BookingStatusType, FilterByType, Language,
  OrderByType, OrderStatus, ResponseStatusType, SortByType, ApprovalStatusType, OriginalBookingStatusType, PaymentChannelType, RefundType,
  PaymentMethodDetailType} from 'app/model/constant';
import { BookingApprovalModel, BookingListModel, DisplayBookingListDTO } from 'app/model/booking/booking-list.model';
import { BookingDetailModel, DisplayBookingDetailDTO } from 'app/model/booking/booking-detail-model';

import { ActHttpService } from '../act-http/act-http.service';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { BookingStatusModel, BookingStatusV2Model } from '../../model/booking/booking-status-model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ProductService } from 'app/services/products/product.service';
import { Response } from '@angular/http';
import { UserService } from 'app/services/user/user.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { environment } from '../../../environments/environment';
import { ResponseContentType } from '@angular/http';
import { MyBookingDetailModel} from 'app/model/booking/my-booking-model';
import { MyBookingDetailModel as MyBookingDetailModelV2, RoomType, HotelInformation, LimitOccupancy } from 'app/model/booking/my-booking-model-v2';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { MyBookingDownloadDocument } from '../../model/booking/my-booking-model';
import { BookingApprovalDetailModel } from 'app/model/approval/approval-detail-model';
import { GuestAmount, BookingInfoSection, OperationDateTime, RoomDetailSection, BookerInfoSection } from '../../components/booking-detail/booking-detail-section';
import { arrivalTimeList } from 'app/utilities/arrival-time-list';

export enum EndBookingStatus {
  'success',
  'fail'
}

@Injectable()
export class BookingService {
  interval = 5000;

  bookingId: string;
  isViewBookingDetail = false;

  processStatus: ResponseStatusType;

  constructor(
    private actHttp: ActHttpService,
    private utilities: UtilitiesService,
    private userService: UserService,
    private appConfigService: AppConfigService,
    private productService: ProductService,
    private translate: TranslatePipe
  ) { }

  getBookingList({ lang, page, limit, searchBy, filterBy, sortBy, orderBy }): any {
    const options = this.actHttp.getRequestOptions();
    const url = `${environment.endpoint.getBookingList}` +
      `?lang=${lang}` +
      `&page=${page}` +
      `&limit=${limit}` +
      `&search=` + encodeURIComponent(searchBy) +
      `&filter=${filterBy}` +
      `&sort=${sortBy}` +
      `&order=${orderBy}`;
    return this.actHttp.get(url, options)
      .map((res: Response) => res.json());
  }

  getBookingDetails(bookingId): Observable<MyBookingDetailModel> {
    const options = this.actHttp.getRequestOptions();
    const url = `${environment.endpoint.getBookingDetails}/${bookingId}` + `?lang=` + this.appConfigService.getLanguage();
    return this.actHttp.get(url, options).map((res: Response) => res.json().data);
  }

  getBookingDetailsV2(bookingId): Observable<MyBookingDetailModelV2> {
    const options = this.actHttp.getRequestOptions();
    const url = `${environment.endpoint.getBookingDetails}/${bookingId}` + `?lang=` + this.appConfigService.getLanguage();
    return this.actHttp.get(url, options).map((res: Response) => res.json().data);
  }

  getBookingSuggestion(bookingId: string = '') {
    return this.actHttp.get(
      `${environment.endpoint.getBookingSuggestion}?bookingId=${bookingId}`,
      this.actHttp.getRequestOptions()
    )
      .map(res => res.json().data);
  }

  getBookingStatus(bookingId: string): Observable<BookingStatusV2Model> {
    const options = this.actHttp.getRequestOptions();
    return this.actHttp.get(
      environment.endpoint.getBookingStatus.replace(':bookingId', bookingId),
      options).map((res: Response) => res.json().data);
  }

  getBookingVoucherPDF(bookingId) {
    const options = this.actHttp.getRequestOptions();
    options.responseType = ResponseContentType.Blob;

    return this.actHttp.get(
      `${environment.endpoint.getBookingVoucherPDF}/${bookingId}`,
      options).map((res: Response) => {
      if (res.status === 200) {
        const _filename = 'VOUCHER-' + bookingId + '.pdf';
        FileSaver.saveAs(res.blob(), _filename, true);
      }
    });
  }

  getOldBookingPDF(bookingId) {
    let _linkPDF = `${environment.endpoint.getOldBookingPDF}`;
    _linkPDF = _linkPDF.replace('{bookingID}', bookingId);
    window.open(_linkPDF);
  }

  getBookingCancellationFee(bookingId): any {
    const options = this.actHttp.getRequestOptions();
    return this.actHttp.get(environment.endpoint.getBookingCancellationFee.replace(':bookingId', bookingId), options)
      .map((res: Response) => res.json());
  }

  cancelBooking(bookingId): any {
    const options = this.actHttp.getRequestOptions();
    const payload = {
      'bookingId': bookingId
    };
    return this.actHttp.post(`${environment.endpoint.cancelBooking}`, payload, options)
      .map((res: Response) => res.json());
  }

  sendBookingCancellation(bookingId): any {
    return false;
  }

  verifyStatusBooking(bookingStatus: BookingStatusV2Model): boolean {
    if (bookingStatus) {
      for (const key in EndBookingStatus) {
        if (bookingStatus.status === EndBookingStatus[key]) {
          return true;
        }
      }
    }
    return false;
  }

  getDiffDate(timeStamp) {
    const date = moment(timeStamp).format('YYYY-MM-DD');
    return moment(date).diff(moment().format('YYYY-MM-DD'), 'days');
  }

  getDateDay(timeStamp) {
    if (typeof timeStamp === 'undefined') {
      return '';
    }

    let _timeStamp;
    if (this.utilities.isSafari() || this.utilities.isIOS()) {
      _timeStamp = timeStamp;
    } else {
      _timeStamp = new Date(timeStamp);
    }

    const lang = this.appConfigService.getLanguage();
    if (lang === Language.en) {
      return moment(_timeStamp).locale(lang).add(7, 'hour').format('ddd');
    } else {
      return moment(_timeStamp).locale(lang).add(7, 'hour').format('dddd');
    }
  }

  getDateAndTimeFormat(timeStamp) {
    if (typeof timeStamp === 'undefined') {
      return '';
    }
    const lang = this.appConfigService.getLanguage();
    return moment(timeStamp).locale(lang).add(7, 'hour').format('dddd D MMMM YYYY HH:mm');
  }

  calculateStatusBooking(orderStatus: BookingStatusModel, checkoutDate: string): BookingStatusType {
    let bookingStatus: BookingStatusType;
    switch (true) {
      // กำลังดำเนินการ
      case (
        orderStatus.orderStatus === OrderStatus.CREATE ||
        orderStatus.orderStatus === OrderStatus.PAID ||
        orderStatus.orderStatus === OrderStatus.BOOK): {
          bookingStatus = BookingStatusType.ON_PROCESS;
        }
        break;

      // จ่ายเงินไม่สำเร็จ
      case (orderStatus.paymentStatus === OrderStatus.FAIL): {
        bookingStatus = BookingStatusType.PAYMENT_FAIL;
      }
        break;

      // ทำรายการไม่สำเร็จ
      case (orderStatus.bookingStatus === OrderStatus.FAIL): {
        bookingStatus = BookingStatusType.BOOKING_FAIL;
      }
        break;

      // ยกเลิกการจอง
      case (
        orderStatus.cancelStatus !== OrderStatus.NO ||
        orderStatus.bookingStatus === OrderStatus.CANCEL): {
          bookingStatus = BookingStatusType.CANCEL;
        }
        break;

      // ชำระเงินเรียบร้อยแล้ว
      case (
        orderStatus.bookingStatus === OrderStatus.SUCCESS &&
        orderStatus.orderStatus === OrderStatus.SUCCESS &&
        orderStatus.paymentStatus === OrderStatus.SUCCESS &&
        (this.getDiffDate(checkoutDate) >= 0)): {
          bookingStatus = BookingStatusType.PAYMENT_SUCCESS;
        }
        break;

      // เช็คเอ้าท์แล้ว
      case (
        orderStatus.bookingStatus === OrderStatus.SUCCESS &&
        orderStatus.orderStatus === OrderStatus.SUCCESS &&
        (orderStatus.paymentStatus === OrderStatus.SUCCESS
          || orderStatus.paymentStatus === OrderStatus.PENDING) &&
        (this.getDiffDate(checkoutDate) < 0)): {
          bookingStatus = BookingStatusType.DEPART;
        }
        break;

      // จองเรียบร้อบแล้ว
      case (
        orderStatus.bookingStatus === OrderStatus.SUCCESS &&
        orderStatus.orderStatus === OrderStatus.SUCCESS): {
          bookingStatus = BookingStatusType.BOOKING_SUCCESS;
        }
        break;
    }
    return bookingStatus;
  }

  transformToBookingStatusModel(data: any): BookingStatusModel {
    return new BookingStatusModel(
      data.orderStatus,
      data.paymentStatus,
      data.bookStatus,
      data.cancelStatus,
    );
  }

  fetchBookingStatus(bookingId: string, interval: number, timeout = 10e3): Observable<boolean> {
    return Observable.interval(interval)
      .timeout(timeout)
      .take(5)
      .flatMap(intervalIndex => {
        return this.getBookingStatus(bookingId)
          .catch((error) => {
            console.log('catch error', error);
            return Observable.empty();
          });
      })
      .flatMap((bookingStatus: BookingStatusV2Model) => {
        return Observable.of(this.verifyStatusBooking(bookingStatus));
      });
  }

  getBookingStatusWithExpectStatus(expectStatus: OriginalBookingStatusType[], bookingId: string, interval: number, timeout = 10e3): Observable<boolean> {
    return Observable.interval(interval)
      .timeout(timeout)
      .take(5)
      .flatMap(intervalIndex => {
        return this.getBookingStatus(bookingId)
          .map(
            res => !!expectStatus.find(
              item => item === res.status
            )
          )
          .catch((error) => {
            console.log('catch error', error);
            return Observable.empty();
          });
      });
  }


  getRoomTypes(bookingProductItems) {
    const _productItems = [];

    bookingProductItems.map((item, i) => {
      item.guests.map((guest, j) => {
        const _productItem = JSON.parse(JSON.stringify(item));
        _productItem.guests = [guest];
        _productItems.push(_productItem);
      });
    });

    return _productItems;
  }

  canCancelBooking(bookingStatus: BookingStatusType, date: any): boolean {
    const statusCanCancel = bookingStatus === BookingStatusType.BOOKING_SUCCESS
      || bookingStatus === BookingStatusType.PAYMENT_SUCCESS
      || bookingStatus === BookingStatusType.WAITING_FOR_APPROVE
      || bookingStatus === BookingStatusType.APPROVE;
    return statusCanCancel && (this.getDiffDate(date) > 0);
  }

  transformBookingListData(booking: BookingListModel): DisplayBookingListDTO {
    const dayFormat = 'dd';
    const dateFormat = 'D';
    const monthYearFormat = 'MMM YY';
    const shortDateFormat = 'D MMM YY';
    const longDateFormat = 'dd D MMM YY';
    const bookingDateFormat = 'D MMMM YYYY';
    const bookingTimeFormat = 'HH:mm';
    const transformData = new DisplayBookingListDTO();
    transformData.productTitle = booking.hotelName ? this.productService.formatDisplayTitle(booking.hotelName) : '';
    transformData.address = booking.hotelAddress ? this.productService.formatDisplayTitle(booking.hotelAddress) : '';
    transformData.dateOrder = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate, null, bookingDateFormat) : '';
    transformData.timeOrder = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate, null, bookingTimeFormat) : '';
    transformData.payOnDate = booking.payOnDate ? this.utilities.convertDateFormat(booking.payOnDate, null, shortDateFormat) : '';
    transformData.approvalDate = booking.approvalDate ? this.utilities.convertDateFormat(booking.approvalDate, null, shortDateFormat) : '';
    transformData.cancellationDate = booking.cancelDate ? this.utilities.convertDateFormat(booking.cancelDate, null, shortDateFormat) : '';
    transformData.dayCheckin = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, dayFormat) : '';
    transformData.dateCheckin = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, dateFormat) : '';
    transformData.monthYearCheckin = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, monthYearFormat) : '';
    transformData.longDateCheckin = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, longDateFormat) : '';
    transformData.dayCheckout = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, dayFormat) : '';
    transformData.dateCheckout = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, dateFormat) : '';
    transformData.monthYearCheckout = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, monthYearFormat) : '';
    transformData.longDateCheckout = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, longDateFormat) : '';
    transformData.ratingStar = booking.hotelStar ? this.utilities.indexToArray(booking.hotelStar) : [];
    transformData.isReviewPublished = !!booking.reviewSubmitDate;
    transformData.reviewUrl = !booking.reviewSubmitDate && booking.reviewToken ? this.generateReviewUrl(booking.reviewToken) : null;
    transformData.totalRoom = booking.quantity;
    transformData.totalAdult = booking.adult;
    transformData.totalChild = booking.child;

    return transformData;
  }

  transformBookingDetailsData(booking: BookingDetailModel): DisplayBookingDetailDTO {
    const formatDateInt = 'YYYY-MM-DD HH:mm:ss';
    const formatDateString = 'D MMM YYYY HH:mm:ss';
    const dayFormat = this.appConfigService.getLanguage() === Language.th ? 'dddd' : 'ddd';
    const transformData = new DisplayBookingDetailDTO();
    transformData.productName = booking.productName ? this.productService.formatDisplayTitle(booking.productName) : '';
    transformData.productAddress = booking.productAddress ? this.productService.formatDisplayTitle(booking.productAddress) : '';
    transformData.ratingStar = booking.ratingStar ? this.utilities.indexToArray(booking.ratingStar) : [];
    transformData.orderDate = booking.dateOrder ? this.utilities.convertDateFormat(booking.dateOrder) : '';
    transformData.orderTime = booking.dateOrder ? this.utilities.convertDateFormat(booking.dateOrder, formatDateInt, 'HH:mm') : '';
    transformData.dateTimeToPay = booking.dateTimeToPay ? this.utilities.convertDateFormat(booking.dateTimeToPay, formatDateString) : '';
    transformData.paymentDate = booking.paymentDate ? this.utilities.convertDateFormat(booking.paymentDate, formatDateString) : '';
    transformData.cancelDate = booking.cancellationDate ? this.utilities.convertDateFormat(booking.cancellationDate, formatDateString) : '';
    transformData.cancellationCharge = booking.cancellationFee ? (+booking.cancellationFee).toFixed(2) : '';
    transformData.refund = booking.totalPrice && booking.cancellationFee ? ((+booking.totalPrice) - (+booking.cancellationFee)).toFixed(2) : '';
    transformData.dayCheckIn = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, formatDateString, dayFormat) : '';
    transformData.checkInDate = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, formatDateString) : '';
    transformData.dayCheckOut = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, formatDateString, dayFormat) : '';
    transformData.checkOutDate = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, formatDateString) : '';
    return transformData;
  }

  transformMyBookingDetailsData(booking: MyBookingDetailModel): DisplayBookingDetailDTO {
    const dayFormat = this.appConfigService.getLanguage() === Language.th ? 'dddd' : 'ddd';
    const transformData = new DisplayBookingDetailDTO();
    transformData.productName = booking.hotelInformation.name ? this.productService.formatDisplayTitle(booking.hotelInformation.name) : '';
    transformData.productAddress = booking.hotelInformation.address ? this.productService.formatDisplayTitle(booking.hotelInformation.address) : '';
    transformData.ratingStar = booking.hotelInformation.star ? this.utilities.indexToArray(booking.hotelInformation.star) : [];
    transformData.orderDate = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate) : '';
    transformData.orderTime = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate, null, 'HH:mm') : '';
    transformData.dateTimeToPay = booking.payOnDate ? this.utilities.convertDateFormat(booking.payOnDate, null) : '';
    transformData.cancelDate = booking.cancellationCharge && booking.cancellationCharge.cancelDate ? this.utilities.convertDateFormat(booking.cancellationCharge.cancelDate, null) : '';
    transformData.cancellationCharge = booking.cancellationCharge && booking.cancellationCharge.cancellationFee ? booking.cancellationCharge.cancellationFee.toString() : '0';
    transformData.refund = booking.cancellationCharge && booking.cancellationCharge.refundAmount ? booking.cancellationCharge.refundAmount.toString() : '0';
    transformData.dayCheckIn = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, dayFormat) : '';
    transformData.checkInDate = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null) : '';
    transformData.dayCheckOut = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, dayFormat) : '';
    transformData.checkOutDate = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null) : '';
    transformData.phone = booking.hotelInformation.phone ? booking.hotelInformation.phone : '';
    return transformData;
  }

  transformMyBookingDetailsDataV2(hotelInformation: HotelInformation): DisplayBookingDetailDTO {
    const transformData = new DisplayBookingDetailDTO();
    transformData.productName = hotelInformation.name ? this.productService.formatDisplayTitle(hotelInformation.name) : '';
    transformData.productAddress = hotelInformation.address ? this.productService.formatDisplayTitle(hotelInformation.address) : '';
    transformData.ratingStar = hotelInformation.star ? this.utilities.indexToArray(hotelInformation.star) : [];
    transformData.phone = hotelInformation.phone ? hotelInformation.phone : '';
    return transformData;
  }

  transformApprovalDetailsData(booking: BookingApprovalDetailModel): DisplayBookingDetailDTO {
    const dayFormat = this.appConfigService.getLanguage() === Language.th ? 'dddd' : 'ddd';
    const transformData = new DisplayBookingDetailDTO();
    transformData.productName = booking.hotelInformation.name ? this.productService.formatDisplayTitle(booking.hotelInformation.name) : '';
    transformData.productAddress = booking.hotelInformation.address ? this.productService.formatDisplayTitle(booking.hotelInformation.address) : '';
    transformData.ratingStar = booking.hotelInformation.star ? this.utilities.indexToArray(booking.hotelInformation.star) : [];
    transformData.orderDate = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate) : '';
    transformData.orderTime = booking.bookingDate ? this.utilities.convertDateFormat(booking.bookingDate, null, 'HH:mm') : '';
    transformData.dateTimeToPay = booking.bookingPayment && booking.bookingPayment.payOnDate ? this.utilities.convertDateFormat(booking.bookingPayment.payOnDate, null) : '';
    transformData.cancelDate = booking.bookingCancellationCharge && booking.bookingCancellationCharge.cancelDate
      ? this.utilities.convertDateFormat(booking.bookingCancellationCharge.cancelDate, null) : '';
    transformData.cancellationCharge = booking.bookingCancellationCharge && booking.bookingCancellationCharge.cancellationFee
      ? booking.bookingCancellationCharge.cancellationFee.toString() : '0';
    if (this.utilities.isMobile()) {
      transformData.dayCheckIn = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, 'dd') : '';
      transformData.dayCheckOut = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, 'dd') : '';
      transformData.checkOutDate = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, 'D MMM YYYY') : '';
      transformData.checkInDate = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, 'D MMM YYYY') : '';
    } else {
      transformData.dayCheckIn = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null, dayFormat) : '';
      transformData.dayCheckOut = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null, dayFormat) : '';
      transformData.checkOutDate = booking.checkOutDate ? this.utilities.convertDateFormat(booking.checkOutDate, null) : '';
      transformData.checkInDate = booking.checkInDate ? this.utilities.convertDateFormat(booking.checkInDate, null) : '';
    }
    return transformData;
  }

  getSortByWithFilter(filter: FilterByType): SortByType {
    let sortBy = SortByType.checkinDate;
    switch (filter) {
      case FilterByType.all:
        sortBy = SortByType.bookingDate;
        break;
      case FilterByType.upComing:
        sortBy = SortByType.checkinDate;
        break;
      case FilterByType.checkin:
        sortBy = SortByType.checkinDate;
        break;
      case FilterByType.departed:
        sortBy = SortByType.bookingDate;
        break;
      case FilterByType.cancelled:
        sortBy = SortByType.bookingDate;
        break;
      case FilterByType.failed:
        sortBy = SortByType.bookingDate;
        break;
    }
    return sortBy;
  }

  getOrderByWithFilter(filter: FilterByType): OrderByType {
    let orderBy = OrderByType.descending;
    if (filter === FilterByType.upComing || filter === FilterByType.checkin) {
      orderBy = OrderByType.ascending;
    }
    return orderBy;
  }

  calculateApprovalStatus(bookingStatus: BookingStatusType, bookingApproval: BookingApprovalModel): BookingStatusType {
    switch (bookingStatus) {
      case BookingStatusType.BOOKING_SUCCESS:
        if (bookingApproval.approvalStatus === ApprovalStatusType.PENDING && !bookingApproval.updateBy) {
          return BookingStatusType.WAITING_FOR_APPROVE;
        } else if (bookingApproval.approvalStatus === ApprovalStatusType.APPROVE && bookingApproval.updateBy === ApprovalUpdateByType.SUPERVISOR) {
          return BookingStatusType.APPROVE;
        } else if (bookingApproval.approvalStatus === ApprovalStatusType.REJECT && bookingApproval.updateBy === ApprovalUpdateByType.SUPERVISOR) {
          return BookingStatusType.REJECT;
        } else {
          return bookingStatus;
        }
      case BookingStatusType.CANCEL:
        if (bookingApproval.approvalStatus === ApprovalStatusType.REJECT) {
          return BookingStatusType.REJECT;
        } else {
          return bookingStatus;
        }
      default:
        return bookingStatus;
    }
  }

  getAccuredReport(from: string, to: string): any {
    const options = this.actHttp.getRequestOptions();

    return this.actHttp.get(`${environment.endpoint.getBookingReport}` +
      `?from=${from}` +
      `&to=${to}`, options)
      .map((res: Response) => {
        return res.json().data
      });
  }

  downloadReport(downloadReportId, interval = 5000, timeout = 10000, take = 180) {
    return Observable.interval(interval)
    .timeout(timeout)
    .take(take)
    .flatMap(intervalIndex => {
      return this.getReportUrl(downloadReportId)
        .catch((err) => {
          if (intervalIndex==take-1) {
            throw Observable.throw(err)
          }
          const errors = err.json().errors

          if (errors[0].code == '5008') {
            throw Observable.throw(err)
          }
          return Observable.empty();
        });
    }).map((res:any) => {
      window.location.href = res.url
      return true
    });
  }

  public getReportUrl(downloadReportId): Observable<any> {
    const url = `${environment.endpoint.getBookingReportUrl}?downloadReportId=${downloadReportId}`;
    const options = this.actHttp.getRequestOptions();
    return this.actHttp.get(url, options).map((res: Response) => res.json().data);
  }

  transformFreeCancellationMsg(freeCancellationDate) {
    return freeCancellationDate ? this.translate
      .transform('product-detail-room-cancellation-free')
      .replace(
        '{date}',
        this.utilities.convertDateFormat(
          freeCancellationDate,
          null,
          'D MMM YYYY'
        )
      ) : null;
  }

  getBookingStatusType(status) {
    for (const bookingStatus in BookingStatusType) {
      if (BookingStatusType[bookingStatus] === status) {
        return bookingStatus;
      }
    }
    return null;
  }

  generateReviewUrl(token: string): string {
    return '/rating?data=' + this.utilities.base64Encoder('{"token":"' + token + '","email":"' + this.userService.getUser().username + '"}') +
    '&lang=' +  this.appConfigService.getLanguage();
  }

  downloadDocument(request: MyBookingDownloadDocument): Observable<any> {
    const options = this.actHttp.getRequestOptions();
    options.responseType = ResponseContentType.Blob;

    const url = `${environment.endpoint.downloadDocument}`;
    return this.actHttp.post(url, request, options).map((res: Response) => {
      if (res.status === 200) {
        FileSaver.saveAs(
          res.blob(),
          this.utilities.extractFileName(res.headers.get('Content-Disposition'), '='),
          true
        );
        return true;
      }
    });
  }

  getLinkDownloadDocument(request: MyBookingDownloadDocument): Observable<any> {
    const options = this.actHttp.getRequestOptions();
    options.responseType = ResponseContentType.Blob;

    const url = `${environment.endpoint.downloadDocument}`;
    return this.actHttp.post(url, request, options).map((res: Response) => {
      if (res.status === 200) {
        const fileURL = URL.createObjectURL(new Blob([res.blob()], { type: 'application/pdf' }));
        return fileURL;
      }
    });
  }

  prepareBookingInfoSection(myBookingDetail: MyBookingDetailModelV2):  BookingInfoSection {
    const prep = new BookingInfoSection();
    prep.bookingId = myBookingDetail.bookingId;
    prep.wsReference = myBookingDetail.wsReference;
    prep.checkIn = new OperationDateTime(myBookingDetail.checkInDate, myBookingDetail.checkInTimeFrom, myBookingDetail.checkInTimeUntil);
    prep.checkOut = new OperationDateTime(myBookingDetail.checkOutDate, myBookingDetail.checkOutTimeFrom, myBookingDetail.checkOutTimeUntil);
    prep.periodOfStay = this.calNight(myBookingDetail.checkInDate, myBookingDetail.checkOutDate);
    prep.roomAmount = myBookingDetail.roomTypes.length;
    if (myBookingDetail.limitOccupancy && myBookingDetail.limitOccupancy.length > 0) {
      prep.occupancyInfo = this.createTotalMaxGuestAmountLimitOccupancy(myBookingDetail.limitOccupancy);
      prep.maxGuest = this.createTotalMaxGuestAmount(myBookingDetail.roomTypes);
    } else {
      prep.occupancyInfo = prep.maxGuest = this.createTotalMaxGuestAmount(myBookingDetail.roomTypes);
    }
    prep.bookingDate = this.utilities.convertDateFormat(myBookingDetail.bookingDate, null, 'D MMMM YYYY');
    prep.bookingTime = this.utilities.convertDateFormat(myBookingDetail.bookingDate, null, 'HH:mm');
    return prep;
  }

  prepareRoomDetailSection(myBookingDetail: MyBookingDetailModelV2, showcancellationPolicies: boolean = false): RoomDetailSection[] {
    const result = [];
    myBookingDetail.roomTypes.forEach(room => {
      const prep = new RoomDetailSection();
      prep.roomTypeName = room.roomTypeName;
      prep.night = this.calNight(myBookingDetail.checkInDate, myBookingDetail.checkOutDate);
      prep.maxGuest = this.createTotalMaxGuestAmount([room]);
      prep.guest = room.guests;
      if (myBookingDetail.arrivalTime) {
        const arrivalTimeKeyTranslate = arrivalTimeList.find(arrivalTime => arrivalTime.value === myBookingDetail.arrivalTime).keyTranslate
        prep.specialRequest = `${this.translate.transform('booking-detail-arrival-time')} : ${this.translate.transform(arrivalTimeKeyTranslate)}`;
        if (room.specialRequest) {
          prep.specialRequest += ', ' + room.specialRequest
        }
      } else {
        prep.specialRequest = room.specialRequest;
      }
      prep.offerType = room.offerTypeName;
      prep.offerTypeDisplay = room.offerTypeDisplay;
      prep.benefits = room.benefits;
      prep.freeCancellationDate = room.freeCancellationDate;
      prep.price = room.price;
      prep.currencyCode = myBookingDetail.bookingPayment.currencyCode;
      prep.showcancellationPolicies = showcancellationPolicies;
      prep.cancellationPolicies = room.cancellationPolicies;
      result.push(prep);
    });

    return result;
  }

  prepareBookersInfoSection(myBookingDetail: MyBookingDetailModelV2): BookerInfoSection[] {
    const result = [];
    myBookingDetail.bookerInformation.forEach( booker => {
      const prep = new BookerInfoSection();
      prep.mainBooker = booker.mainBooker;
      prep.fullName = booker.fullName;
      prep.phone = booker.phone;
      prep.email = booker.email;
      if (booker.creditTermsInformation) {
        prep.creditTermsInfo = booker.creditTermsInformation.taxAddressInformation ? booker.creditTermsInformation.taxAddressInformation : null;
        if (booker.creditTermsInformation.bookingApproval) {
          prep.approval = booker.creditTermsInformation.bookingApproval;
        }
      }
      if (booker.creditCardInformation) {
        prep.creditCardInfo = booker.creditCardInformation.taxAddressInformation ? booker.creditCardInformation.taxAddressInformation : null;
      }
      if (booker.trueMoneyInformation) {
        prep.trueMoneyInfo = booker.trueMoneyInformation.taxAddressInformation ? booker.trueMoneyInformation.taxAddressInformation : null;
      }
      if (booker.qrCodeInformation) {
        prep.qrCodeInfo = booker.qrCodeInformation.taxAddressInformation ? booker.qrCodeInformation.taxAddressInformation : null;
      }
      if (booker.eWalletInformation) {
        prep.eWalletInfo = booker.eWalletInformation.taxAddressInformation ? booker.eWalletInformation.taxAddressInformation : null;
      }
      if (booker.imBankingInformation) {
        prep.imBankingInfo = booker.imBankingInformation.taxAddressInformation ? booker.imBankingInformation.taxAddressInformation : null;
      }
      if (booker.payAtCounterInformation) {
        prep.payAtCounterInfo = booker.payAtCounterInformation.taxAddressInformation ? booker.payAtCounterInformation.taxAddressInformation : null;
      }
      prep.paymentChannel = this.calculatePaymentChannel(myBookingDetail.bookingPayment.paymentMethod);
      if (booker.checkoutFields) {
        prep.checkoutFields = booker.checkoutFields.length > 0 ? booker.checkoutFields : null;
      }
      result.push(prep);
    });

    return result;
  }

  calculatePaymentChannel(paymentStringFromMyBookingDetail: string) {
    let paymentChannel = PaymentChannelType.CREDIT_TERMS;
    switch(paymentStringFromMyBookingDetail){
      case PaymentMethodDetailType.MULTI_PAYMENT:
        paymentChannel = PaymentChannelType.MULTI_PAYMENT;
        break;
      case PaymentMethodDetailType.CREDIT_CARD:
        paymentChannel = PaymentChannelType.CREDIT_CARD;
        break;
      case PaymentMethodDetailType.TRUE_MONEY:
        paymentChannel = PaymentChannelType.TRUE_MONEY;
        break;
      case PaymentMethodDetailType.CORPORATE_FLEET:
        paymentChannel = PaymentChannelType.CORPORATE_FLEET;
        break;
      case PaymentMethodDetailType.PERSONAL_FLEET:
        paymentChannel = PaymentChannelType.PERSONAL_FLEET;
        break;
      case PaymentMethodDetailType.QR_CODE:
        paymentChannel = PaymentChannelType.QR_CODE;
        break;
      case PaymentMethodDetailType.E_WALLET:
        paymentChannel = PaymentChannelType.E_WALLET;
        break;
      case PaymentMethodDetailType.IM_BANKING:
        paymentChannel = PaymentChannelType.IM_BANKING;
        break;
      case PaymentMethodDetailType.PAY_AT_COUNTER:
        paymentChannel = PaymentChannelType.PAY_AT_COUNTER;
        break;
      default:
        break;
    }
    return paymentChannel;
  }

  calculateRefundType(totalPrice: number, cancellationFee: number) {
    if (totalPrice == cancellationFee) {
      return RefundType.NON_REFUND
    }
    else if(cancellationFee == 0) {
      return RefundType.FULL_REFUND
    }
    else {
      return RefundType.PARTIAL_REFUND
    }
  }

  calNight(checkinDate: any, checkOutDate: any): number {
    const date1 = new Date(checkinDate);
    const date2 = new Date(checkOutDate);
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());

    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  }

  createTotalMaxGuestAmount(rooms: RoomType[]) {
    let adult = 0;
    let child = 0;
    rooms.forEach(room => {
      adult += room.maxAdult;
      child += room.maxChild;
    });

    return new GuestAmount(adult, child);
  }

  createTotalMaxGuestAmountLimitOccupancy(rooms: LimitOccupancy[]) {
    let adult = 0;
    let child = 0;
    let childrenAge: number[] = [];
    rooms.forEach(room => {
        adult += room.adult;
        child += room.children;
        childrenAge = childrenAge.concat(room.childrenAge);
    });
    childrenAge.sort((a, b) => a - b);
    return new GuestAmount(adult, child, childrenAge);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/booking/booking.service.ts